import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  makeStyles,
  Avatar,
  Grid,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import E_Notification_Period from "./_dropdown";
import { Skeleton } from "@material-ui/lab";

const useStyle = makeStyles((theme) => ({
  appBar: {
    background: theme.palette.ePrimary?.base,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: "1202",
  },
  toolbar: {
    minHeight: "45px",
    justifyContent: "space-between",
  },
  avatarStyle: {
    width: "25px",
    height: "25px",
    fontSize: "inherit",
    background: theme.palette.eDanger?.dark,
  },
}));
export default function E_card_Header({ title, data, origin, setData, labelReady,setAnnLoad ,setMeterLoad,meterLoad,annLoad }) {
  let classes = useStyle();
  let count = useSelector((state) => state?.e_meterAlertsDataCount?.data);
  let [originCount, setCount] = useState(0);
  useEffect(() => {
    if (origin && count) {
      if (origin === "PREPAID") {
        setCount(0);
      } else {
        origin && setCount(count[origin]?.length);
        let tempData = data.filter((item) => item.IsRead === 0);
        if (tempData.length > 0) {
          localStorage.setItem(origin, JSON.stringify(tempData));
        }
      }
    }
  }, [data, origin, count, count?.[origin]?.length]);

  return (
    <AppBar position="static" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Grid container spacing={1} >
        {
          labelReady?
          <Grid item>
            {" "}
            <Typography variant="h6">{title}</Typography>
          </Grid>
          : <Skeleton />
        }
          <Grid item>
            {" "}
            {originCount > 0 && (
              <Avatar className={classes.avatarStyle}>{originCount}</Avatar>
            )}
          </Grid>
        </Grid>
        <E_Notification_Period origin={origin} allData={data} setData={setData} setAnnLoad={setAnnLoad}
              setMeterLoad={setMeterLoad}
              meterLoad={meterLoad}
              annLoad={annLoad}/>
      </Toolbar>
    </AppBar>
  );
}
